import React from "react";
import { ListCheck } from "../../icons/ListCheck";
import { UtensilsCrossed4 } from "../../icons/UtensilsCrossed4";
import { Music } from "../../icons/Music";
import { CableCar3 } from "../../icons/CableCar3";
import { IconTab } from "./IconsTab";

// Define the icon map outside to avoid recreating it on each call
const iconMap = {
  all: (state) => <ListCheck className="!relative !w-6 !h-6" state={state} />,
  restaurant: (state) => <UtensilsCrossed4 className="!relative !w-6 !h-6 utensils-crossed-restaurant" state={state} />,
  dining: (state) => <UtensilsCrossed4 className="!relative !w-6 !h-6 utensils-crossed-dining" state={state} />,
  music: (state) => <IconTab className="!relative !w-6 !h-6" state={state} icon={"EventBlack"} />,
  activities: (state) => <IconTab className="!relative !w-6 !h-6" state={state} icon={"CableCarWhite"} />,
  events: (state) => <IconTab className="!relative !w-6 !h-6" state={state} icon={"EventBlack"} />,
};

export const getIconForFilter = (name, state,noIconOnNull=false) => {
  return (iconMap[name] || iconMap.all)(state);
};



const placeIconMap = {
    all: (state) => <ListCheck className="!relative !w-4 !h-4" state={state} />,
    restaurant: (state) => <UtensilsCrossed4 className="!relative !w-4 !h-4 utensils-crossed-restaurant" state={state} />,
    dining: (state) => <IconTab className="!relative !w-4 !h-4 utensils-crossed-dining" state={state} icon={"DinningGrey"} />,
    music: (state) => <IconTab className="!relative !w-4 !h-4" state={state} icon={"CalenderHeartGrey"} />,
    activities: (state) => <CableCar3 className="!relative !w-4 !h-4 activities-icon" state={state} icon={"CableCarWhite"} />,
    events: (state) => <IconTab className="!relative !w-4 !h-4 events-icon-tab" state={state} icon={"CalenderHeartGrey"} />,
  };
  
  export const getIconForPlace = (name, state,noIconOnNull=false) => {
    return (placeIconMap[name] || placeIconMap.all)(state);
  };



